/* Méga-menu CHAMBRE 01 (section c01-mega) */
if (!customElements.get('c01-mega')) {
  customElements.define('c01-mega', class extends HTMLElement {
    connectedCallback() {
      this.panels = [...this.querySelectorAll('[data-mega-panel]')];
      this.overlay = this.querySelector('[data-mega-overlay]');
      this.delay = Number(this.dataset.closeDelay) || 160;
      this.injectButton();
      this.bind();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.injectSearch());
      else this.injectSearch();
      document.addEventListener('click', (e) => { if (e.target.closest('search-button, .search-action')) setTimeout(() => this.injectSearch(), 0); });
      this.panels.forEach((p) => {
        p.addEventListener('pointerenter', () => clearTimeout(this.timer));
        p.addEventListener('pointerleave', () => this.scheduleClose());
      });
      this.overlay.addEventListener('pointerenter', () => this.close());
      this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      window.addEventListener('scroll', () => { if (this.current) this.place(); }, { passive: true });
    }
    get header() { return document.querySelector('#header-component'); }
    bind() {
      const items = document.querySelectorAll('header-menu .menu-list__list-item');
      if (!items.length) { setTimeout(() => this.bind(), 300); return; }
      items.forEach((li) => {
        if (li.dataset.c01Mega) return;
        li.dataset.c01Mega = '1';
        const a = li.querySelector('a.menu-list__link');
        if (!a) return;
        const href = a.getAttribute('href');
        const panel = this.panels.find((p) => p.dataset.trigger === href);
        li.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'touch') return;
          clearTimeout(this.timer);
          panel ? this.open(panel, a) : this.close();
        });
        li.addEventListener('pointerleave', () => this.scheduleClose());
        if (panel) a.setAttribute('aria-haspopup', 'true');
      });
    }
    injectButton() {
      const tpl = this.querySelector('template[data-mega-button]');
      const right = document.querySelector('#header-component .header__column--right');
      if (!tpl || !right || right.querySelector('.c01-header-button')) return;
      right.prepend(tpl.content.cloneNode(true));
    }
    injectSearch() {
      const modal = document.querySelector('#search-modal');
      if (!modal) return;
      const input = modal.querySelector('.search-input');
      if (input && this.dataset.searchPlaceholder) input.placeholder = this.dataset.searchPlaceholder;
      const tpl = this.querySelector('template[data-search-pills]');
      const wrapper = modal.querySelector('.predictive-search-form__content-wrapper');
      if (tpl && wrapper && !modal.querySelector('.c01-search-pills')) wrapper.before(tpl.content.cloneNode(true));
    }
    place() {
      const row = this.header?.querySelector('.header__row--top');
      if (!row) return;
      const r = row.getBoundingClientRect();
      this.style.setProperty('--mega-top', `${Math.round(r.bottom + 8)}px`);
      this.style.setProperty('--mega-left', `${Math.round(r.left)}px`);
    }
    open(panel, link) {
      this.place();
      const header = this.header;
      if (header) header.classList.add('c01-mega-active');
      this.panels.forEach((p) => (p.hidden = p !== panel));
      document.querySelectorAll('header-menu .menu-list__link').forEach((a) => a.classList.toggle('c01-mega__current', a === link));
      this.current = panel;
      this.classList.add('is-open');
    }
    scheduleClose() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.close(), this.delay);
    }
    close() {
      clearTimeout(this.timer);
      if (!this.current) return;
      this.classList.remove('is-open');
      this.panels.forEach((p) => (p.hidden = true));
      document.querySelectorAll('.c01-mega__current').forEach((a) => a.classList.remove('c01-mega__current'));
      const header = this.header;
      if (header) header.classList.remove('c01-mega-active');
      this.current = null;
    }
  });
}
